export class GenderParent {
  constructor() {
    this.list = []
  }

  addGender(item) {
    this.list.push(Gender.buildFromAPI(item))
  }

  updateGender(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, Gender.buildFromAPI(item))
  }

  removeGender(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => Gender.buildFromAPI(el))
    }
    return this
  }
}

export class Gender {
  constructor() {
        this.id = null
        this.name = null
      }

  getForAPI() {
    return {
            id: this.id,
            name: this.name,
          }
  }

  static buildFromAPI(obj) {
    const _this = new Gender()
    if (obj) {
            _this.id = obj.id
            _this.name = obj.name
          }
    return _this
  }
}